<form
    [formGroup]="studentForm"
    class="form new-student-form"
    (ngSubmit)="onSubmit(studentForm.value)"
    *ngIf="successfulSubmission === false && alreadyComplete === false"
>
    <fieldset class="form-section">
        <legend>General Info</legend>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="ssn"
                    class="label"
                >
                    SSN
                </label>
                <input
                    class="input"
                    id="ssn"
                    [class.input--invalid]="formErrors.ssn"
                    formControlName="ssn"
                    mask="000-00-0000"
                    [dropSpecialCharacters]="true"
                >
                <div
                    *ngIf="formErrors.ssn"
                    class="error-message field__error-message"
                >
                    {{ formErrors.ssn }}
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="firstName"
                        class="label"
                    >
                        First Name
                    </label>
                    <input
                        class="input"
                        id="firstName"
                        [class.input--invalid]="formErrors.firstName"
                        formControlName="firstName"
                        appUpperCase
                        maxlength="30"
                    >
                    <div
                        *ngIf="formErrors.firstName"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.firstName }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="middleName"
                        class="label"
                    >
                        Middle Name
                        <span class="label__help-text">(optional)</span>
                    </label>
                    <input
                        class="input"
                        id="middleName"
                        [class.input--invalid]="formErrors.middleName"
                        formControlName="middleName"
                        appUpperCase
                        maxlength="30"
                    >
                    <div
                        *ngIf="formErrors.middleName"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.middleName }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="lastName"
                        class="label"
                    >
                        Last Name
                    </label>
                    <input
                        class="input"
                        [class.input--invalid]="formErrors.lastName"
                        id="lastName"
                        formControlName="lastName"
                        appUpperCase
                        maxlength="30"
                    >
                    <div
                        *ngIf="formErrors.lastName"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.lastName }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="suffix"
                        class="label"
                    >
                        Suffix
                        <span class="label__help-text">(optional)</span>
                    </label>
                    <select
                        class="input input--select-menu"
                        id="suffix"
                        formControlName="suffix"
                    >
                        <option value>Select One</option>
                        <option value="JR">JR</option>
                        <option value="SR">SR</option>
                        <option value="I">I</option>
                        <option value="II">II</option>
                        <option value="III">III</option>
                        <option value="IV">IV</option>
                        <option value="V">V</option>
                        <option value="VI">VI</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="gender"
                        class="label"
                    >
                        Gender
                    </label>
                    <select
                        class="input input--select-menu"
                        [class.input--invalid]="formErrors.gender"
                        id="gender"
                        formControlName="gender"
                    >
                        <option value>Select One</option>
                        <option value="F">Female</option>
                        <option value="M">Male</option>
                        <option value="N">Non-binary</option>
                        <option value="P">Prefer not to say</option>
                    </select>
                    <div
                        *ngIf="formErrors.gender"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.gender }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item ">
                <div class="field__label-input-wrap">
                    <label
                        for="birthday"
                        class="label"
                    >
                        Date of Birth
                    </label>
                    <input
                        *ngIf="appSettings.IsCompatibilityMode === true"
                        required
                        class="input"
                        [class.input--invalid]="formErrors.birthday"
                        id="birthday"
                        formControlName="birthday"
                        type="text"
                        mask="00/00/0000"
                        placeholder="MM/DD/YYYY"
                    >
                    <input
                        *ngIf="appSettings.IsCompatibilityMode === false"
                        required
                        class="input"
                        [class.input--invalid]="formErrors.birthday"
                        id="birthday"
                        formControlName="birthday"
                        type="date"
                        placeholder="mm/dd/yyyy"
                    >
                    <div
                        *ngIf="formErrors.birthday"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.birthday }}
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <fieldset class="form-section">
        <legend>Contact Info</legend>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="country"
                    class="label"
                >
                    Country
                </label>
                <select
                    class="input input--select-menu input--large"
                    [class.input--invalid]="formErrors.countryId"
                    id="country"
                    formControlName="countryId"
                >
                    <option value>Select One</option>
                    <option
                        *ngFor="let c of countries"
                        [value]="c.id"
                    >
                        {{c.description}}
                    </option>
                </select>
                <div
                    *ngIf="formErrors.countryId"
                    class="error-message field__error-message"
                >
                    {{ formErrors.countryId }}
                </div>
            </div>
        </div>
        <div class="field  ">
            <div class="field__label-input-wrap">
                <label
                    for="address1"
                    class="label"
                >
                    Address 1
                </label>
                <input
                    class="input  input--large"
                    [class.input--invalid]="formErrors.address1"
                    id="address1"
                    formControlName="address1"
                    appUpperCase
                    maxlength="35"
                >
                <div
                    *ngIf="formErrors.address1"
                    class="error-message field__error-message"
                >
                    {{ formErrors.address1 }}
                </div>
            </div>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="address2"
                    class="label"
                >
                    Address 2
                    <span class="label__help-text">(optional)</span>
                </label>
                <input
                    class="input  input--large"
                    [class.input--invalid]="formErrors.address2"
                    id="address2"
                    formControlName="address2"
                    appUpperCase
                    maxlength="35"
                >
                <div
                    *ngIf="formErrors.address2"
                    class="error-message field__error-message"
                >
                    {{ formErrors.address2 }}
                </div>
            </div>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="postalCode"
                    class="label"
                >
                    Zip&#x2F;Postal Code
                </label>
                <input
                    class="input"
                    id="postalCode"
                    [maxlength]="isUs ? 5 : 10"
                    [mask]="isUs ? '00000' : 'SSSSSSSSSS'"
                    [dropSpecialCharacters]="true"
                    (blur)="performZipCodeLookup()"
                    [class.input--invalid]="formErrors.postalCode"
                    formControlName="postalCode"
                >
                <div
                    *ngIf="formErrors.postalCode"
                    class="error-message field__error-message"
                >
                    {{ formErrors.postalCode }}
                </div>
                <div
                    *ngIf="badZipMessage"
                    class="error-message field__error-message"
                >
                    The zip code you entered cannot be found. Please verify you correctly entered the zip code. If you require further assistance contact NBRC.
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item ">
                <div class="field__label-input-wrap">
                    <label
                        for="city"
                        class="label"
                    >
                        City
                    </label>
                    <input
                        class="input"
                        id="city"
                        [class.input--invalid]="formErrors.city"
                        formControlName="city"
                        appUpperCase
                    >
                    <div
                        *ngIf="formErrors.city"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.city }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="state"
                        class="label"
                    >
                        State
                    </label>
                    <input
                        class="input"
                        id="state"
                        [class.input--invalid]="formErrors.state"
                        formControlName="state"
                        appUpperCase
                    >
                    <div
                        *ngIf="formErrors.state"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.state }}
                    </div>
                </div>
            </div>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="email"
                    class="label"
                >
                    Email
                </label>
                <input
                    class="input input--medium"
                    id="email"
                    [class.input--invalid]="formErrors.email"
                    formControlName="email"
                    type="email"
                    appUpperCase
                >
                <div
                    *ngIf="formErrors.email"
                    class="error-message field__error-message"
                >
                    {{ formErrors.email }}
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="homePhone"
                        class="label"
                    >
                        Home Phone
                        <span class="label__help-text">(optional)</span>
                    </label>
                    <input
                        class="input"
                        [class.input--invalid]="formErrors.homePhone"
                        formControlName="homePhone"
                        id="homePhone"
                        type="tel"
                        mask="0*"
                        [dropSpecialCharacters]="true"
                    >
                    <div
                        *ngIf="formErrors.homePhone"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.homePhone }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="cellPhone"
                        class="label"
                    >
                        Cell Phone
                    </label>
                    <input
                        class="input"
                        [class.input--invalid]="formErrors.cellPhone"
                        formControlName="cellPhone"
                        id="cellPhone"
                        type="tel"
                        mask="0*"
                        [dropSpecialCharacters]="true"
                    >
                    <div
                        *ngIf="formErrors.cellPhone"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.cellPhone }}
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <fieldset class="form-section">
        <legend>School Info</legend>
        <div class="data-item">
            <div class="data-item__label label">School Name</div>
            <div class="data-item__value">{{schoolName}} - {{schoolCode}}</div>
        </div>
    </fieldset>
    <div class="form-actions">
        <input
            class="button form-actions__item"
            type="submit"
            value="Update Profile"
        >
        <div
            *ngIf="formLevelErrors"
            class="error-message field__error-message"
        >
            <p *ngFor="let error of formLevelErrors">{{error}}</p>
        </div>
    </div>
</form>
<form
    *ngIf="successfulSubmission === true"
    style="text-align:center;margin:0;"
>
    <p>Thank you for completing your profile.</p>
</form>
<form
    *ngIf="alreadyComplete === true"
    style="text-align:center;margin:0;"
>
    <p>
        This profile has either been completed or has expired. Contact our office at
        <u>portalsupport@nbrc.org</u>
        for further assistance.
    </p>
</form>
